var render, staticRenderFns
import script from "./AxButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./AxButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AxButtonGroup.vue?vue&type=style&index=0&id=3179ef8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179ef8d",
  null
  
)

export default component.exports